import { render, staticRenderFns } from "./taskantiga.vue?vue&type=template&id=19406d20&"
import script from "./taskantiga.vue?vue&type=script&lang=js&"
export * from "./taskantiga.vue?vue&type=script&lang=js&"
import style0 from "./taskantiga.vue?vue&type=style&index=0&id=19406d20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports